import { NavLink, Outlet } from 'react-router-dom';
import { Brand } from '../components/Brand';
import { useApp } from './AppContext';

const navItems = [
  { to: '/', label: 'ホーム', end: true },
  { to: '/calibration', label: '測定の準備' },
  { to: '/history', label: '記録' },
  { to: '/settings', label: '設定' },
];

export function AppShell() {
  const { calibration, environment } = useApp();
  const date = new Intl.DateTimeFormat('ja-JP', {
    year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
  }).format(new Date());

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">メインへ移動</a>
      <header className="site-header">
        <div className="site-header-inner">
          <Brand />
          <nav className="side-nav" aria-label="メインナビゲーション">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end}>{item.label}</NavLink>
            ))}
          </nav>
          <div className="top-status" title={calibration ? `${Math.round(environment?.refreshRateHz ?? 0)} Hzで確認済み` : 'トレーニング開始前に設定します'}>
            <span className={`status-dot ${calibration ? '' : 'uncalibrated'}`} />
            <span>{calibration ? '準備済み' : '準備が必要'}</span>
          </div>
        </div>
      </header>
      <div className="app-main">
        <div className="top-bar"><time className="top-clock">{date}</time></div>
        <main id="main-content" tabIndex={-1}><Outlet /></main>
      </div>
    </div>
  );
}
